import http from "./httpService";
import config from "../config.json";

const apiEndpoint = config.apiEndpoint + "/seasons";

export async function getSeasons() {
  const response = await http.get(apiEndpoint); //.catch(err => console.log(err.response));
  return response.data;
}

export async function getSeason(id) {
  const response = await http.get(apiEndpoint + "/" + id);
  return response.data;
}

export async function saveSeason(season) {
  let seasonInDb = season || {};
  seasonInDb.name = season.name;

  if (seasonInDb.id === -1) await http.post(apiEndpoint, seasonInDb);
  else await http.put(apiEndpoint + "/" + seasonInDb.id, seasonInDb);

  return seasonInDb;
}

export async function deleteSeason(id) {
  await http.delete(apiEndpoint + "/" + id);
}



// WEBPACK FOOTER //
// ./src/services/seasonService.js